import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from '../../../../app/shared/model/page-grid';
import {removeEmptyParams} from "../../../../infrastructure/helper/remove-empty-params";
import {IErpOutboundItem} from '../interfaces/erp-outbound-panel.interface';
import {ErpOutboundPanelFilterService} from './erp-outbound-panel-filter.service';
import moment from 'moment';
import {Sort} from '@angular/material/sort';

@Injectable({
  providedIn: 'root'
})
export class ErpOutboundReportGridService implements GridGetService<IErpOutboundItem> {
  private readonly baseUrl = 'dbov2/adx-invoice-erp-responses';
  private readonly http = inject(HttpClient);
  private readonly filterService = inject(ErpOutboundPanelFilterService);

  getItems({page, sort}: GridServiceParams): Observable<GridServiceResponse<IErpOutboundItem>> {
    const filters = this.filterService.filtersValue();

    const params: Record<string, string | number | boolean | string[] | number[]> = {
      pageSize: page?.pageSize || 25,
      pageNumber: (page?.pageIndex || 0) + 1,
      propertyName: this.mapSortPropertyName(sort),
      orderKey: sort?.direction || '',
      invoiceNumber: filters?.InvoiceNumber ?? '',
      pnr: filters?.PNR ?? '',
      erpMessageId: filters?.ErpMessageId ?? '',
      erpOrderNumber: filters?.ErpOrderNumber ?? '',
      legalEntityId: filters?.LegalEntityId ?? '',
      queueName: filters?.QueueName ?? '',
      responseType: filters?.ResponseType ?? '',
      result: filters?.Result ?? '',
      createdDateFrom: filters?.CreatedDateFrom ? moment(filters.CreatedDateFrom).format('YYYY-MM-DD') : '',
      createdDateTo: filters?.CreatedDateTo ? moment(filters.CreatedDateTo).format('YYYY-MM-DD') : '',
      adxInvoiceId: filters?.AdxInvoiceId ?? '',
      hasSalesOrderNumber: filters?.HasSalesOrderNumber ?? '',
      hasAdxInvoiceId: filters?.HasAdxInvoiceId ?? ''
    };

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<IErpOutboundItem>>(this.baseUrl, {params: {...params}})
      .pipe(catchError((error: HttpErrorResponse) => {
        throw new Error(error?.message || 'Server error');
      }));
  }

  private mapSortPropertyName(sort?: Partial<Sort>) {
      if (!sort?.active) return '';
      const propertyNameMap: { [key: string]: string } = {
        'legalEntityName': 'legalEntity.name'
      };
      return propertyNameMap[sort.active] || sort.active;
  }
}
